import { Component, Input, OnInit } from '@angular/core';
import { Anexos } from '../../models/anexos.model';
import { ActivatedRoute } from '@angular/router';
import { AnexosService } from '../../services/anexos.service';
import { AnexosResolver } from '../../resolver/anexos.resolver';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ApresentacaoService } from '../../services/apresentacao.service';

@Component({
  selector: 'app-apresentacao-anexos',
  templateUrl: './apresentacao-anexos.component.html',
  styleUrls: ['./apresentacao-anexos.component.scss']
})
export class ApresentacaoAnexosComponent extends BaseFormComponent<Anexos> implements OnInit {

  id:number;
  currentAttachId:number;
  data: Anexos;
  @Input() print:boolean = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ApresentacaoService,
    public anexosResolver: AnexosResolver
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }
  
  start(){
    if(this.id && this.id != 0){
      this.anexosResolver.getAll( this.id ).subscribe({
        next: (data) => {
          var newData = data;
          this.entity = newData;
          this.data = newData;
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
    }
    else{
      this.loaded();
    }
  }

  download(attachId:number, fileName:string): void {
    this.loading();
    this.myService.downloadFile(attachId,'ac').subscribe({
      next: (res) => {
        this.downloadFile(res, fileName);
      },
      error: (error) => {
        console.error('Erro ao baixar o arquivo:', error);
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  downloadFile(res, fileName:string) {
    const blob = new Blob([res.body], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
    this.loaded();
  }


}
